import React from 'react';

function HtmlComponent(props) {
  return (
      <span className="html-component" dangerouslySetInnerHTML={{__html:props.value}}></span>
  );
}

export default HtmlComponent;